var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContentoh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.04181 6.99321C5.94396 6.99321 7.48596 5.42773 7.48596 3.49661C7.48596 1.56548 5.94396 0 4.04181 0C2.13966 0 0.597656 1.56548 0.597656 3.49661C0.597656 5.42773 2.13966 6.99321 4.04181 6.99321Z",
    fill: "#D4D1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8611 6.99321C17.7633 6.99321 19.3053 5.42773 19.3053 3.49661C19.3053 1.56548 17.7633 0 15.8611 0C13.959 0 12.417 1.56548 12.417 3.49661C12.417 5.42773 13.959 6.99321 15.8611 6.99321Z",
    fill: "#D4D1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.0991C0 13.0991 8.96526 17.3011 20 13.0991C20 13.0991 17.8334 19.0001 10.5417 19.0001C3.24991 19.0001 0 13.0991 0 13.0991Z",
    fill: "#D4D1D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContentoh);
export default __webpack_public_path__ + "static/media/iconContentoh.7982b35e3cf373aea39231e17ffef071.svg";
export { ForwardRef as ReactComponent };